import React from "react";  



export default function TemplteError (props){
 return(
    <>
  
    <p><b>{props.name} : </b>  Component Not Found!</p>
    </>
 )
}